function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fillRule: "evenodd",
  className: "tickSvg"
}, React.createElement("ellipse", {
  className: "tickCircle",
  cx: 12,
  cy: 12,
  fill: "#fff",
  rx: 11,
  ry: 11
}), React.createElement("path", {
  className: "tickOutline",
  fill: "#004152",
  d: "M12,22.5c5.8,0,10.5-4.7,10.5-10.5S17.8,1.5,12,1.5S1.5,6.2,1.5,12S6.2,22.5,12,22.5 M24,12 c0,6.7-5.3,12-12,12S0,18.7,0,12S5.3,0,12,0S24,5.3,24,12"
}), React.createElement("path", {
  className: "tickMark",
  fill: "#004152",
  d: "M7.3,10.5l-1.8,1.7l4.8,5.7l8.2-10.3L16.6,6l-6.4,8L7.3,10.5z"
}));

var SvgTickInCircle = function SvgTickInCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTickInCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick-in-circle.3a8f6d21.svg";
export { ForwardRef as ReactComponent };